import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-field-officer-form',
  templateUrl: './field-officer-form.component.html',
  styleUrls: ['./field-officer-form.component.css']
})
export class FieldOfficerFormComponent implements OnInit {
  title="Field Officer Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/field-officer/field-officer-form/field-officer-form.component.ts